import { RoleClient } from '../../components/constants/Consts';



const clientAdminRoutes = [
    'ADMIN-SYS-GROUP',

    '/home', 
    '/myaccount/profile', 
    '/myclient', 
    '/clients/subcon', '/clients/subcon/*',
    '/clients/subcon/newsubcon',
    '/users/newuser',
    '/users', '/users/*', 
    '/newemployer',
    '/myemployer',
    '/employers', '/employers/*', 
    '/employers/worksites/*', 
    '/employers/new-worksite',

    '/newemployer',
    '/employees', '/employees/*', 
    '/newemployee',
    '/employees/authzs/iscir/*',
    '/employees/authzs/internal/*',
    '/employees/newauthz-iscir',    // should it be -> /employees/authzs/iscir/new ???
    '/employees/newauthz-internal',

    '/employees/authzcourse/*',
    '/employees/newauthzcourse',

    '/equipment', 
    '/deserventi-calendar',

    '/rsvti/deserventi/tasks', 
    '/rsvti/deserventi/tasks/new-couponstamp',
    '/rsvti/deserventi/tasks/couponstamp/*',
    '/rsvti/deserventi/tasks/new-certificate',
    '/rsvti/deserventi/tasks/certificate/*',

    '/rsvti/equipment',
    '/rsvti/reports',
    '/test/parent', '/test/parent/*'
];

const clientUserSpecificERRoutes = [
    '/home', 
    '/myaccount/profile', 
    '/myemployer',
    '/employers', '/employers/*', 
    '/employers/worksites/*', 

    '/employees', '/employees/*', 
    '/newemployee',
    '/employees/authzs/iscir/*',
    '/employees/authzs/internal/*',
    '/employees/newauthz-iscir',
    '/employees/newauthz-internal',

    '/employees/authzcourse/*',
    '/employees/newauthzcourse',

    '/equipment', 
    '/deserventi-calendar',

    '/rsvti/deserventi/tasks', 
    '/rsvti/deserventi/tasks/new-couponstamp',
    '/rsvti/deserventi/tasks/couponstamp/*',
    '/rsvti/deserventi/tasks/new-certificate',
    '/rsvti/deserventi/tasks/certificate/*',

    '/rsvti/equipment',
    '/rsvti/reports',
    '/test/parent', '/test/parent/*'
];


export const authorizationRoutes = new Map([
    [RoleClient.Admin, clientAdminRoutes],
    [RoleClient.User, clientAdminRoutes],
    [RoleClient.UserSpecificEmployer, clientUserSpecificERRoutes],
]);